export default __webpack_public_path__ + "static/sales-analytics-83b717aa7f25638cfaa36f1aea71a692.png";